/**
 * The person cancelled the passkey confirmation of their answer (AC-109), take-back or move (AC-126):
 * nothing was sent. A module of its own so the answer toast, in the launch entry, can tell it apart
 * without taking up the signing code (`signedAnswer.ts`, the chain check) with it.
 */
export class PresenceCancelledError extends Error {
  constructor() {
    super('The passkey confirmation was cancelled.');
    this.name = 'PresenceCancelledError';
  }
}
